// extracted by mini-css-extract-plugin
export default {"detail":"Progress_detail__cVyVs","progress_bar":"Progress_progress_bar__uKRaf","progress_level":"Progress_progress_level__X89kC","progress_line":"Progress_progress_line__BbAg6"};